import type { ReactNode } from 'react';

export const symbol_arrow_menu_open: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-150v-660q0-13 8.5-21.5T390-840q13 0 21.5 8.5T420-810v660q0 13-8.5 21.5T390-120q-13 0-21.5-8.5T360-150Zm175-186v-288q0-10 8.5-13.5T560-634l138 132q9 9 9 22t-9 22L560-326q-8 7-16.5 3.5T535-336Z"
		/>
	</svg>
);
